import { connect } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { withTranslation } from "next-i18next";
import Cookies from "js-cookie";
import Button from "@components/core/Button";
import { useCurrentUser } from "@hooks/use-current-user";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import catalogContexts from "@utils/constants/catalogContexts";
import closetStates from "@utils/constants/closetStates";
import SwapUserFeedbackRating from "./SwapUserFeedbackRating";
import SwapUserFeedbackComment from "./SwapUserFeedbackComment";

function SwapUserFeedback({
  context,
  secondsUntilModalAppears,
  t, 
}) {
  const user = useCurrentUser();
  const customizableCloset = useCustomizableCloset();

  const [displayModal, setDisplayModal] = useState(false);
  const [displayArrowButton, setDisplayArrowButton] = useState(false);
  const [feedbackId, setFeedbackId] = useState("");
  const [displayCommentModalContent, setDisplayCommentModalContent] = useState(false);

  const intervalID = useRef();

  function displayUserFeedback() {
    if (!Cookies.get('swap_notation')) return;

    const cookieObj = JSON.parse(Cookies.get('swap_notation'));
    const { startingTime, userRefusedNotation } = cookieObj;
    const xSecondsOnTheSwap = Number(startingTime) + secondsUntilModalAppears * 1000;
    if (new Date().getTime() < xSecondsOnTheSwap) return;

    setDisplayArrowButton(true);
    if (!userRefusedNotation) {
      setDisplayModal(true);
      clearInterval(intervalID.current);
    } else {
      setDisplayModal(false);
    }
  }

  function setIntervalToCheckToDisplayFeedback() {
    const id = setInterval(displayUserFeedback, 400);
    intervalID.current = id;
  }

  function evaluateCookie() {
    if (!Cookies.get('swap_notation')) {
      Cookies.set('swap_notation', {
        startingTime: new Date().getTime(),
        userRefusedNotation: false,
      },
      { expires: 1 });
      return;
    }

    const cookieObj = JSON.parse(Cookies.get('swap_notation'));
    const { startingTime, userRefusedNotation } = cookieObj;

    if (!startingTime) {
      Cookies.set('swap_notation', {
        startingTime: new Date().getTime(),
        userRefusedNotation,
      },
      { expires: 1 });
    }

    Cookies.set('swap_notation', {
      startingTime,
      userRefusedNotation,
    },
    { expires: 1 });
  }

  function hideOrDisplayModal() {
    setDisplayModal(!displayModal);

    if (Cookies.get('swap_notation')) {
      const cookieObj = JSON.parse(Cookies.get('swap_notation'));
      const { startingTime, userRefusedNotation } = cookieObj;
      Cookies.set('swap_notation', {
        startingTime,
        userRefusedNotation: !userRefusedNotation,
      },
      { expires: 1 });
    }
  }

  function hideFeedback() {
    setDisplayModal(false);
    setDisplayArrowButton(false);
  }

  useEffect(() => {
    if (user?.feedback_available) {
      evaluateCookie();
      setIntervalToCheckToDisplayFeedback();
    }
    return () => {
      clearInterval(intervalID.current);
    };
  }, []);

  if (context !== catalogContexts.swap || !user?.id || customizableCloset?.state !== closetStates.readyToChange) return null;

  return (
    <div className={displayModal ? "swap-feedback-container-active" : "swap-feedback-container"}>
      {displayArrowButton
        && (
          <div className={displayModal ? "swap-feedback-btn" : "swap-feedback-btn-close"}>
            {displayModal ? (
              <Button
                key="btn-feedback-chevron-down"
                title={t("feedbacks:open")}
                variant="ghost-dark"
                size="sm"
                onClick={hideOrDisplayModal}
                leftIconName="chevron-down"
                className="mt-n2"
              />
            ) : (
              <Button
                key="btn-feedback-chevron-up"
                title={t("feedbacks:close")}
                variant="ghost-dark"
                size="sm"
                onClick={hideOrDisplayModal}
                leftIconName="chevron-up"
                className="mt-n2"
              />
            )}

          </div>
        )}
      <SwapUserFeedbackRating
        closetId={customizableCloset.id}
        setFeedbackId={setFeedbackId}
        setDisplayCommentModalContent={setDisplayCommentModalContent}
      />
      <SwapUserFeedbackComment
        feedbackId={feedbackId}
        displayCommentModalContent={displayCommentModalContent}
        hideFeedback={hideFeedback}
      />
    </div>
  );
}

const mapStateToProps = (store) => ({
  closetId: store.customizableCloset?.currentCloset?.id,
  secondsUntilModalAppears: store.advertising?.feedback?.seconds_until_swap_modal_appears,
});

export default withTranslation("feedbacks")(connect(mapStateToProps, { })(SwapUserFeedback));
